import { ChangeEvent, useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
} from '@mui/material';
import { ExternalLink } from 'types';

interface Props {
  open: boolean;
  selectedLink: ExternalLink | undefined;
  handleSubmit: ({ name, link }: { name: string; link: string }) => void;
  handleClose: () => void;
}

const CreateExternalLinkDialog = ({
  open,
  selectedLink,
  handleSubmit,
  handleClose,
}: Props) => {
  const [link, setLink] = useState<{ name: string; link: string }>({
    name: '',
    link: '',
  });

  useEffect(() => {
    if (!selectedLink) {
      setLink({
        name: '',
        link: '',
      });
      return;
    }

    setLink({
      name: selectedLink.name,
      link: selectedLink.link,
    });
  }, [selectedLink]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setLink({
      ...link,
      [name]: value,
    });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {selectedLink ? 'Update Link' : 'Create New Link'}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          id='name'
          label='Name'
          name='name'
          fullWidth
          variant='outlined'
          value={link.name}
          onChange={handleChange}
          error={link.name.trim().length === 0}
          helperText={
            link.name.trim().length === 0 && `Link Name Can't be Empty`
          }
        />
        <TextField
          autoFocus
          margin='dense'
          id='link'
          label='Link'
          name='link'
          fullWidth
          variant='outlined'
          value={link.link}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose}>
          Cancel
        </Button>
        <Button variant='contained' onClick={() => handleSubmit(link)}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateExternalLinkDialog;
